import { render, staticRenderFns } from "./ArticleCardList.vue?vue&type=template&id=1ed84819"
import script from "./ArticleCardList.vue?vue&type=script&lang=js"
export * from "./ArticleCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports